import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  params: null,
  reasons: [],
  fromdishes: [],
  updateProduction: [],
  loading: false,
  error: null,
};

export const fetchFromDish = createAsyncThunk(
  'updateProductionPlan/getFromDish',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/GetFromDish`, payload);
    return response?.data?.data?.dishes;
  }
);

export const fetchAllReasons = createAsyncThunk(
  'updateProductionPlan/getAllReasons',
  async () => {
    const response: any = await axiosInstance.get(`${BASE_URL}/api/v1/ProductionPlan/GetAllReasons`, {});
    return response?.data?.data;
  }
);

export const fetchDayPartCode = createAsyncThunk(
  'productionPlan/fetchDayParts',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetDayPart`, payload);
    return response?.data?.data?.daypartlist;
  }
);


export const fetchUpdateProductionPlan = createAsyncThunk(
  'updateProductionPlan/fetchUpdateProductionPlan',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/GetUpdateProductionPlan`, payload);
    return response?.data?.data?.updateproduction;
  }
);

export const saveUpdateProductionPlan = createAsyncThunk(
  'updateProductionPlan/saveUpdateProductionPlan',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/SaveProductionPlan`, payload);
    return response?.data;
  }
);


export const submitUpdateProductionPlan = createAsyncThunk(
  'updateProductionPlan/submitUpdateProductionPlan',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/submitProductionPlan`, payload);
    return response?.data;
  }
);


const updateProductionSlice = createSlice({
  name: 'updateProductionPlan',
  initialState,
  reducers: {
    setParams(state, action) {
      state.params = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFromDish.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFromDish.fulfilled, (state, action) => {
        state.loading = false;
        state.fromdishes = action.payload;
      })
      .addCase(fetchFromDish.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchAllReasons.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllReasons.fulfilled, (state, action) => {
        state.loading = false;
        state.reasons = action.payload;
      })
      .addCase(fetchAllReasons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchUpdateProductionPlan.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUpdateProductionPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.updateProduction = action.payload; 
      })
      .addCase(fetchUpdateProductionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setParams } = updateProductionSlice.actions;

export default updateProductionSlice.reducer;
